import React, { useEffect, useRef } from "react";

type PhoneInputProps = {
    defaultValue?: string;                 // "(999) 999-99-99"
    onChange: (masked: string) => void;    // вернуть маску наверх
    error?: string;
    inputClassName?: string;              // если надо переопределить
    prefixClassName?: string;
    errorClassName?: string;
};

export const PhoneForm: React.FC<PhoneInputProps> = ({
                                                          defaultValue = "",
                                                          onChange,
                                                          error = "",
                                                          inputClassName = "profile-input",
                                                          prefixClassName = "profile-phone-prefix",
                                                          errorClassName = "profile-error",
                                                      }) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    // чтобы при открытии модалки можно было прокинуть новое defaultValue
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = defaultValue || "";
        }
    }, [defaultValue]);

    // ✅ ТВОЙ JS: оставил логику максимально дословно
    function handleTelInput(e: React.FormEvent<HTMLInputElement>) {
        const target = e.currentTarget;

        let inputValue = target.value;
        let lastChar = inputValue.charAt(inputValue.length - 1);

        if (isNaN(Number(lastChar)) || lastChar === " " || inputValue.length === 16) {
            target.value = inputValue.slice(0, -1);
            if (inputValue.endsWith(") ")) target.value = inputValue.slice(0, -2);

            onChange(target.value);
            return;
        }

        if (inputValue.length === 1) target.value = "(" + inputValue;
        if (inputValue.length === 5) target.value = inputValue.slice(0, 4) + ") " + lastChar;
        if (inputValue.length === 10) target.value = inputValue.slice(0, -1) + "-" + lastChar;
        if (inputValue.length === 13) target.value = inputValue.slice(0, -1) + "-" + lastChar;

        onChange(target.value);
    }

    return (
        <div className="profile-phone">
            <div className="profile-phone-wrap">
                <span className={prefixClassName}>+7</span>

                <input
                    ref={inputRef}
                    type="text"
                    className={inputClassName}
                    placeholder="(999) 999-99-99"
                    onInput={handleTelInput}
                    defaultValue={defaultValue}
                    aria-invalid={!!error}
                />
            </div>
        </div>
    );
};
